<template>
  <HpsfirProDrawer
    v-model:open="visible"
    title="模板列表"
    width="80vw"
    max-width="1200px"
    content-class="business-table-drawer"
    body-class="business-table-drawer__body"
  >
    <HpsfirProTable
      v-if="visible"
      ref="tableRef"
      export-file-name="模板列表"
      :columns="columns"
      :get-data="getData"
      :on-delete="deleteFun"
      :loading="loading"
      :is-dangder-delete="true"
      :format-dangder-delete-info="formatDeleteInfo"
      row-key="id"
      :operates="operates"
      :add-init-values="addInitValue"
      :codition-init-values="conditionsInitValue"
    />
    <HpsfirProDangerDialog
      ref="setTplDialog"
      title="选用警告"
      opt-name="选用"
      :on-ok="handleSetTpAction"
      :format-dangder-delete-info="setTplDangderInfo"
    />
  </HpsfirProDrawer>
</template>
<script lang="ts" setup>
import {
  useBaseAsync,
  type HpsfirProTableColumn,
  type HpsfirProTableData,
  type HpsfirProTableFilter,
  type HpsfirProTableGetDataFunction,
  type HpsfirProFormItem,
} from 'hpsfir-managebase-ui';

import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import dayjs from 'dayjs';
import { normalizeBizTableColumns } from '@/utils/tableColumns';

const emit = defineEmits<{(e: 'setTpl', data: any): void;}>();


const columns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([]));
const tableRef = ref<any>();
const setTplDialog = ref<any>();

const visible = ref(false);
const addInitValue = {

};
const conditionsInitValue = {
};


// eslint-disable-next-line max-lines-per-function
const init = useBaseAsync(() => {
  columns.value = normalizeBizTableColumns([
    {
      name: 'templateId',
      label: '模板ID',
      type: 'number',
    },
    {
      name: 'templateType',
      label: '模板类型',
      type: 'select',
      rule: [{ required: true }],
      options: [
        {
          label: '普通模板',
          value: 0,
        },
        {
          label: '标准模板',
          value: 1,
        },
      ],
    },
    {
      name: 'currentVersion',
      label: '版本',
      type: 'string',
    },
    {
      name: 'description',
      label: '描述',
      type: 'string',
      width: 200,
    },
    {
      name: 'auditScene',
      label: '场景',
      type: 'string',
    },
    {
      name: 'auditStatus',
      label: '审核状态',
      type: 'searchSelect',
      options: [
        {
          label: '未提交审核',
          value: 0,
        },
        {
          label: '审核中',
          value: 1,
        },
        {
          label: '审核中',
          value: 2,
        },
        {
          label: '审核通过',
          value: 3,
        },
        {
          label: '提审中',
          value: 4,
        },
        {
          label: '提审失败',
          value: 5,
        },
      ],
    },
    {
      name: 'reason',
      label: '驳回原因',
      type: 'string',
    },
    {
      name: 'createTime',
      label: '创建时间',
      type: 'string',
      width: 80,
      hideCreate: true,
      hideEdit: true,
      render: (scope: any) => (scope?.row?.createTime ? dayjs(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss') : ''),
    },

  ]);
});


const operates: any[] = [
  {
    key: 'setTpl',
    name: '选用当前模板库',
    handler: useBaseAsync((row: any) => {
      setTplDialog.value?.showDialog(row);
    }),
  },
];

const loading = ref(false);


const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().weappTplApi.getTplListweappTpl();
    const tableData: HpsfirProTableData = {
      total: res.data.data?.length || 0,
      data: res.data.data || [],
    };

    return tableData;
  } finally {
    loading.value = false;
  }
});

const handleSetTpAction = useBaseAsync((data: any) => {
  emit('setTpl', data);
  visible.value = false;
});
const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().weappTplApi.delTplweappTpl(data.templateId);
  ElMessage.success('删除成功');
});

const formatDeleteInfo = (row: any) => `您正在进行删除(${row.templateId})操作，请谨慎操作`;

const setTplDangderInfo = (row: any) => `您正在进行选用模板(${row.templateId})操作，请保证当前所有在用小程序都在正常状态`;

init();
defineExpose({
  show: () => {
    tableRef.value?.refresh();
    visible.value = true;
  },
});

</script>
<style lang="scss" scoped>
</style>
